export enum AmendEmailDialogFormNamesEnum {
  FORM_NAME = 'AmendEmailDialog',
  EMAIL = 'Email',
}
